<template>
  <div>
    <div
      v-for="state in states"
      :key="state.id + 'Transition'"
    >
      <!--
      <img
        @click="goHome"
        class="bgImg"
        :src="bgSrc(state)"
        v-show="currentTransition === state.id + 'In'" />
      -->

      <vue-video
        playerClass="bgVideo"
        :playerId="state.id + 'In'"
        v-show="currentTransition === state.id + 'In' || currentAnnotation === state.id + 'Annotation0'"
        :autoplay="true"
        :src="findVideo(state.id + '_IN')"
        @click="goHome"
        @ended="transitionEnded"
        >
      </vue-video>

      <vue-video
        playerClass="bgVideo"
        :playerId="state.id + 'Out'"
        v-show="currentTransition === state.id + 'Out'"
        :autoplay="true"
        :src="findVideo(state.id + '_OUT')"
        @click="goHome"
        @ended="transitionEnded"
        >
      </vue-video>
    </div>
  </div>
</template>

<script>
import util from '../assets/js/util'

import VueVideo from '@/components/VueVideo'

export default {
  components: { VueVideo },
  methods: {
    bgSrc (state) {
      return require('@/assets/img/' + this.prefix + '/' + state.id + '-Stop.png')
    },
    findVideo (mp4) {
      return util.staticPrefix() + 'mp4/' + this.prefix + '/' + mp4
    },
    goHome () {
      this.$emit('go-home')
    },
    transitionEnded () {
      this.$emit('transition-ended')
    }
  },
  name: 'Transitions',
  props: {
    currentAnnotation: {
      type: String,
      default: ''
    },
    currentTransition: {
      type: String,
      default: ''
    },
    prefix: {
      type: String,
      default: ''
    },
    states: {
      type: Array,
      default: function () {
        return []
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bgImg {
  filter: blur(10px);
}
</style>
